<template>
  <base-tile :title="$t('invites.info')" i18nPrefix="users" :rows="state.rows">
    <!-- ID -->
    <template #[state.readUserIdSlot]>
      <td v-if="state.id" class="p-2">
        <span>{{ state.id }} </span>
        <button-clipboard-copy :field="$t('invites.id')" :value="state.id" />
      </td>
    </template>

    <!-- EMAIL -->
    <template #[state.email]>
      <td v-if="state.email" class="p-2">
        <span>{{ state.email }} </span>
        <button-clipboard-copy
          :field="$t('invites.email')"
          :value="state.email"
        />
      </td>
    </template>

    <!-- RELATED ID -->
    <template #[state.relatedIdSlot]>
      <td v-if="getRelatedId()" class="p-2">
        <router-link :to="{ path: getRelatedLink() }">
          {{ getRelatedId() }}
        </router-link>
        <button-clipboard-copy
          :field="getRelatedIdLabel()"
          :value="getRelatedId()"
        />
      </td>
      <td v-else class="p-2">-</td>
    </template>
  </base-tile>
</template>

<script setup>
import { computed, reactive } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import BaseTile from "@/components/BaseTile.vue";
import ButtonClipboardCopy from "@/components/ButtonClipboardCopy.vue";
import { printDate } from "@/utils";
import { organizationLink } from "@/utils/identity";
import { entitlementLink } from "@/utils/licensing";

const { t } = useI18n();
const store = useStore();

const state = reactive({
  rows: computed(() => {
    const users = store.state?.identity?.user;
    console.log(users);
    const baseRows = [
      {
        label: t("invites.id"),
        value: users?.id,
        copyable: true
      },
      {
        label: t("invites.createdAt"),
        value: printDate(users?.createdAt)
      },
      {
        label: t("invites.email"),
        value: users?.email,
        copyable: true
      },
      {
        label: t("invites.purpose"),
        value: users?.purpose
      },
      {
        label: t("invites.ProductName"),
        value: users?.productName
      }
    ];

    // Add related ID row if applicable
    const relatedId = getRelatedId();
    if (relatedId) {
      baseRows.push({
        label: getRelatedIdLabel(),
        value: relatedId,
        copyable: true,
        link: getRelatedLink()
      });
    }

    baseRows.push(
      {
        label: t("invites.url"),
        value: users?.url
      },
      {
        label: t("invites.deliveryCount"),
        value: users?.deliveryCount
      },
      {
        label: t("invites.acceptedAt"),
        value: printDate(users?.lastSubmittedAt)
      }
    );

    return baseRows;
  }),
  readUserIdSlot: `${t("users.id")}-value`,
  readUserEmailSlot: `${t("users.email")}-value`,
  relatedIdSlot: `${t("invites.relatedId")}-value`
});

const getRelatedId = () => {
  const invite = store.state?.identity?.user;
  if (invite?.purpose === "JoinOrganization" && invite?.resourceId) {
    return invite.resourceId;
  }
  if (invite?.purpose === "GetLicense" && invite?.resourceId) {
    return invite.resourceId;
  }
  return null;
};

const getRelatedLink = () => {
  const invite = store.state?.identity?.user;
  if (invite?.purpose === "JoinOrganization" && invite?.ressourceId) {
    return organizationLink(invite.resourceId);
  }
  if (invite?.purpose === "GetLicense" && invite?.resourceId) {
    return entitlementLink(invite.resourceId);
  }
  return "#";
};

const getRelatedIdLabel = () => {
  const invite = store.state?.identity?.user;
  if (invite?.purpose === "JoinOrganization") {
    return t("invites.organizationId");
  }
  if (invite?.purpose === "GetLicense") {
    return t("invites.entitlementId");
  }
  return t("invites.relatedId");
};
</script>
